<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path stroke="#000" stroke-linecap="round" stroke-width="2" d="M1 2h2.004a1 1 0 0 1 .964.734L6.6 12.266a1 1 0 0 0 .964.734h8.342a1 1 0 0 0 .968-.75l1.803-7A1 1 0 0 0 17.71 4H9.692"/><circle cx="6.5" cy="17.5" r="1.5" fill="#000"/><circle cx="16.5" cy="17.5" r="1.5" fill="#000"/></svg>
</template>
<script>
export default {
  name: "CartIcon"
}
</script>

<style lang="scss">

</style>